
import { defineComponent, ref, reactive, toRefs, onMounted, nextTick, watch } from 'vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import Collapse from '@/components/paragraphColl.vue'
export default defineComponent({
  components: { Collapse },
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    size: {
      type: String,
      default: () => {
        return ''
      }
    },
    bordered: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props: any, context) {
    const route = useRoute()
    const pageData: any = reactive({
      list: props.data,
      newimg: require('@/assets/new.svg'),
      key: '' + new Date().getTime(),
      softNameAbbr: route.query.softNameAbbr
    })
    function openbox(item: any) {
      item.open = !item.open
    }
    function gotolink(href: string) {
      if (pageData.softNameAbbr === 'jfztGW') {
        window.open(href)
      } else {
        window.open(`gw://openurl?param=${href}`)
      }
    }
    onMounted(() => {
      nextTick(() => {
        // window.addEventListener("resize",()=>{
        //   pageData.key = '' + new Date().getTime()
        // })
        // window.onresize = function () {
        //   pageData.key = '' + new Date().getTime()
        // }
      })
    })
    return {
      ...toRefs(pageData),
      openbox,
      gotolink
    }
  }
})
